import * as types from 'store/modules/hres6bu/mutation-types'
import hres6bu from 'api/hres6bu'
import swal from 'sweetalert'
import hres6buLabels from 'assets/labels/hres6bu'
import { hres6buMaxRowspan, hres6buColumns } from 'assets/columns/hres6bu'
import configLabel from 'src/../config/label'
import { sendApprove } from 'assets/js/sendApprove.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres6buLabels,
    maxRowspan: hres6buMaxRowspan,
    columns: hres6buColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab3: {}
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES6BU_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES6BU_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES6BU_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRES6BU_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES6BU_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES6BU_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES6BU_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES6BU_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES6BU_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES6BU_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES6BU_MAX_ROWSPAN] (state, maxRowspan) {
      state.maxRowspan = maxRowspan
    },
    [types.SET_HRES6BU_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2, labels[keyLang])
      }
    },
    [types.SET_HRES6BU_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES6BU_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES6BU_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES6BU_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES6BU_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES6BU_INDEX_DISP, indexDisp)
      commit(types.SET_HRES6BU_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES6BU_COLUMNS_LABELS] ({ commit }) {
      hres6bu.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6BU_COLUMNS, data.labels)
          commit(types.SET_HRES6BU_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6BU_INDEX] ({ commit }, searchParams) {
      hres6bu.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6BU_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6BU_DETAIL] ({ commit }, searchParams) {
      hres6bu.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6BU_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES6BU_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres6bu.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES6BU_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6bu/index.js